import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useBrand } from "../../lib/brand";

export const STAGE_TONE = {
  development: "default", prototype: "blue", fitting: "blue", corrections: "gold",
  final_sample: "gold", approved: "green", production: "green",
};
export const PRIORITY_LABEL = { low: "Bassa", normal: "Normale", high: "Alta", urgent: "Urgente" };
export const eur = (v) => `€ ${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (iso) => (iso ? new Date(iso.length === 10 ? `${iso}T12:00:00` : iso).toLocaleDateString("it-IT") : "—");

export function useBrandMembers() {
  const { activeBrand } = useBrand();
  const [members, setMembers] = useState([]);
  useEffect(() => {
    if (!activeBrand?.id) return;
    api.get(`/brands/${activeBrand.id}/members`)
      .then(r => setMembers(r.data.map(m => ({ id: m.user_id, name: m.user?.name || m.user?.email || m.name || m.email || "—" }))))
      .catch(() => {});
  }, [activeBrand?.id]);
  return members;
}

export const Card = ({ title, action, children, testId, id }) => (
  <div className="card-dark p-6 mb-6" data-testid={testId} id={id}>
    {(title || action) && (
      <div className="flex items-center justify-between mb-4 gap-3">
        <div className="label-caps">{title}</div>{action}
      </div>
    )}
    {children}
  </div>
);
